import RequestManager from "./RequestManager";

const getAllProductVersions = async (domainId) => {
    const response = await RequestManager.get({
        url: `/product/version/v2/${domainId}`,
        showError: false
    });
    return response;
};

const getAllProducts = async () => {
    const response = await RequestManager.get({
        url : `/product/v2`
    });
    return response;
};

const getAllDeploymentsByProductForDomain = async (domainId) => {
    const response = await RequestManager.get({
        url: `/product/domain/v1/${domainId}`
    });
    return response;
};

const getDomainPromptInfo = async (domainId) => {
    const response = await RequestManager.get({
        url: `/product/domain/promptInfo/v1/${domainId}`
    });
    return response;
};

const getProductVersion = async (id) => {
    const response = await RequestManager.get({
        url: "/product/version/v1/" + id
    });
    return response;
};

const createProduct = async (body) => {
    const response = await RequestManager.post({
        url: "/product/v1",
        body
    });
    return response;
};

const createProductVersion = async (productId, body) => {
    const response = await RequestManager.post({
        url: `/product/version/v1/${productId}`,
        body
    });
    return response;
};

const deleteProductVersion = async (versionId) => {
    const response = await RequestManager.del({
        url: `/product/version/v1/${versionId}`
    });
    return response;
};

const deleteProduct = async (productId) => {
    const response = await RequestManager.del({
        url: `/product/v1/${productId}`
    });
    return response;
};

const updateProductVersion = async (versionId, body) => {
    const response = await RequestManager.put({
        url: `/product/version/v1/${versionId}`,
        body
    });
    return response;
};

const updateProduct = async (productId, body) => {
    const response = await RequestManager.put({
        url: `/product/v1/${productId}`,
        body
    });
    return response;
};

const isProductAssigned = async (id) => {
    const response = await RequestManager.get({
        url: `/product/assigned/v1/${id}`
    });
    return response;
};

const isProductVersionAssigned = async (id) => {
    const response = await RequestManager.get({
        url: `/product/version/assigned/v1/${id}`
    });
    return response;
};

const migrateProductVersion = async (body) => {
    const response = await RequestManager.put({
        url: `/product/version/migrate/v1`,
        body
    });
    return response;
}

const updateTemplateMetadata = async (id, data) => {
    return await RequestManager.put({
        url: `/product/version/templateMetadata/v1/${id}`,
        body: data
    });
};

const Product = {
    getAllProductVersions,
    getAllProducts,
    getProductVersion,
    createProduct,
    createProductVersion,
    updateProductVersion,
    deleteProductVersion,
    deleteProduct,
    updateProduct,
    getAllDeploymentsByProductForDomain,
    getDomainPromptInfo,
    isProductAssigned,
    isProductVersionAssigned,
    migrateProductVersion,
    updateTemplateMetadata
};

export default Product;